module.exports = __webpack_public_path__ + "img/imghuiytj-wxz.b3eae2e2.png";